export interface StepBadgesProps {
  total: number;
  processed: number;
  currentIndex?: number;
  titles?: string[];
}

export default function StepBadges({ total, processed, currentIndex, titles = [] }: StepBadgesProps) {
  if (total <= 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5 py-2">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`w-6 h-6 rounded flex items-center justify-center font-mono text-xs transition-all duration-300 ease-in-out ${
            i < processed
              ? 'bg-emerald-600 text-white shadow-sm'
              : i === (currentIndex ?? -1)
                ? 'bg-blue-600 text-white animate-pulse shadow-md'
                : 'bg-navy-700 text-gray-500 hover:bg-navy-600'
          }`}
          title={titles[i] || `Objeto ${i + 1}${i < processed ? ' - Concluído' : i === (currentIndex ?? -1) ? ' - Processando' : ' - Pendente'}`}
        >
          {i + 1}
        </div>
      ))}
    </div>
  );
}


